import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from './../../../../shared/util/util';
import Multiselect from 'vue-multiselect'
 import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
 import BookingService from './../../../../cargobooking/services/cargobooking.service';
 import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import PickuprequestCSV from './../../pickuprequestcsv';
const moment = require('moment');
export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    DatePicker,
	Multiselect,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading,
	PickuprequestCSV,
    TripServices
  },
  props: ['selectedEditRowData'],
  data() {
    return {
      isLoading:false,
      pickupPinCode:"",
      Location:null,
      service:"Surface",
      Product:null,
      servicelist:[],
      productlist:[],
      Locationlist:[],
      contactpersonfirmname:"",
      Mobile:"",
      Email:"",
      City:"",
      pickupAddress:"",
      shipmentweight:"",
      noOfBoxes:"",
      shipmentvolume:"",
      pickupInstruction:"",
      destinationPinCode:"",
      companyNamelist:[],
      companyName:null,
      telephone:"",
	  userRoleFlag: '',
	  clientid: '',
	  actualwtconfigparam: {},
	  BookingMode: 'Credit',
      RouteMode: 'Surface',
      TruckLoadType: 'PTL',
      DestinationHub: '',
      DestinationHubId: '',
	  OriginHub: '',
      OriginHubId: '',
      State: '',
      ConsigneeState: '',
      ConsigneeCity: '',
	  PickupPincodeServicable: 2,
      DestinationPincodeServicable: 2,
      pincodeservicabilitycheckflag: false,
	  sourcepincodeerrmsg: '',
      destinationpincodeerrmsg: '',
      clientbusinessaccid: '',
	  clientName:'',
	  defaultHubID: '',
	  PinCode:'',
	  LocationName: "",
	  editLocation:false,
	  editPincode : false,
	  RequestedPickupDate: Util.getCurrentDateOnly(),
	  editBasicDetailsflag: false,
	  todaysDate:'',
	  clientbusinessaccountid:'',
	  clientbusinessdetailid:'',
	  uploadcsv: false,
	  businessaccountname:'',
	  isBasicInfoLoading:false,
	  AddNewLocationFlag:false,
	  editCityFlag:false,
		tabs: [
			{ key: 'First', value: 'Create Pickup Request' }
		],
		currentTab: 'First',
		componentKey:1,
      actiontype:'add',
	  requestpickupid:'',
	  disabledflag:false,
	  updateflag:false,
	  GstNo: null,
	  PRCutoffcheck: false,
	  prcutofftimestr: "",
	  PRCutOffTime:[],
	  serverdatetime:"",
	  validate_urp:"",
	  maxDate:"",
	  PRwtThreshold:500,
	  thresholdErr:false
    }
  },
  computed: {
	currentTabComponent: function () {
		this.componentKey += 1;
		this.uploadcsv = false;
		return this.currentTab.toLowerCase();
	  }
  },
  async mounted() {
	this.getPRCutOffTime();
	this.getPRWtThreshold();
	if(this.companyNamelist.length==0){
		this.getCompanyShortName();
	  }
	this.getServerTime('mounted');
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID;
    this.HubId = userdetail.hubID[0];
    this.HubName = userdetail.currentHubName;
    // this.HubId = 24;
	this.todaysDate = Util.getCurrentDateOnly();
	this.maxDate = Util.getFutureDateOnly(30);
	this.userRoleFlag = (userdetail.rolename[0] == "Hub Executive" || userdetail.rolename[0] == "Hub Incharge" || userdetail.rolename[0] == "Hub Manager") ? 1 : 2;
	
	if(this.selectedEditRowData.id){
		if(this.selectedEditRowData.pickuprequeststatus!='Pending' || this.selectedEditRowData.status == 0){
			this.updateflag = true
		}
	this.clientName = {
        id: this.selectedEditRowData.clientbusinessaccountid,
        label: this.selectedEditRowData.clientname,
        ClientId: this.selectedEditRowData.clientid,
        ClientBusinessAccountId : this.selectedEditRowData.clientbusinessaccountid,
        ClientBusinessDetailId :  this.selectedEditRowData.clientbusinessaccountid,
      }
	this.Location = {
		'id': this.selectedEditRowData.pickuplocation,
		'label': this.selectedEditRowData.pickuplocation,
		'mobile': this.selectedEditRowData.mobile,
		'telephone': Number(this.selectedEditRowData.alternatemobile),
		'email': this.selectedEditRowData.email,
		'address':this.selectedEditRowData.pickupaddress,
		'gstno': this.selectedEditRowData.pickupgst
	}
	this.City =this.selectedEditRowData.pickupcity
	this.OriginHubId = this.selectedEditRowData.originhubid
	this.OriginHub = this.selectedEditRowData.originhub
	this.businessaccountname  =  this.selectedEditRowData.clientname
	this.shipmentweight =this.selectedEditRowData.totalwt
	this.destinationPinCode =(this.selectedEditRowData.destinationpincode).toString()
	this.RequestedPickupDate =this.selectedEditRowData.requestedpickupdate
	this.contactpersonfirmname =this.selectedEditRowData.contactname
	this.pickupPinCode =(this.selectedEditRowData.pickuppincode).toString()
	this.clientbusinessaccountid =this.selectedEditRowData.clientbusinessaccountid
	this.pickupInstruction =this.selectedEditRowData.pickupinstruction
	this.actiontype =this.selectedEditRowData.action
	this.requestpickupid = this.selectedEditRowData.id
	this.clientid = this.selectedEditRowData.clientid
	this.noOfBoxes = this.selectedEditRowData.numberofmps
	this.State = this.selectedEditRowData.pickupstate
	this.ConsigneeState = this.selectedEditRowData.destinationstate
	this.ConsigneeCity = this.selectedEditRowData.destinationcity
	this.DestinationHubId = this.selectedEditRowData.destinationhubid
	this.DestinationHub = this.selectedEditRowData.destinationhub
	this.editBasicDetailsflag = true
	if(this.pickupPinCode && this.destinationPinCode){
		  this.editBasicDetailsflag	= true
		  this.editPincode = true
		  this.disabledflag = true
		//  this.editLocation = true	
		  this.pincodeservicabilitycheckflag = true
		  this.PickupPincodeServicable = 1
		  this.DestinationPincodeServicable = 1
	  }
	//   this.AddNewLocationFlag = false
	this.tabs[0].value = "Update Pickup request"
	this.RouteMode = this.selectedEditRowData.routemode;
	this.BookingMode = this.selectedEditRowData.bookingmode == 'FTC' ? 'To Pay' : this.selectedEditRowData.bookingmode
	}

  },
  created() {
    this.$root.$refs.createTripManagement = this;
  },
  methods: {
    callParent() {
		this.startTrip = false;
		this.showAddShipment	= false
    },
    showRequestedPickuplist() {
			this.$emit("goBackToParent")
    },
    selectedProduct(){

    },
    selectedLocation(){
	  if (this.Location) {
		this.Mobile = this.Location.mobile;
		this.telephone = this.Location.telephone;
		this.Email = this.Location.email;
		this.pickupAddress = this.Location.address;
		this.GstNo = this.Location.gstno
		} else {
		this.Mobile = "";
		this.Telephone = "";
		this.Email = "";
		this.Address = "";
		this.GstNo = null;
	  }
	},
	selectedClient(data){
		if(data){
			this.ActiveContract = data.ContractId;
			this.businessaccountname = data.CompanyName;
			this.clientid = data.ClientId
			this.clientbusinessaccountid = data.ClientBusinessAccountId;
			this.clientbusinessdetailid = data.ClientBusinessDetailId;
			this.clientbusinessaccid = data.ClientBusinessAccountId;
		}
	},
	addNewLocation() {
		this.LocationName = null;
		this.Mobile = "";
		this.telephone = "";
		this.Email = "";
		this.pickupAddress = "";
		this.GstNo = null;
		this.contactname =""
		this.AddNewLocationFlag = true;
		this.editBasicDetailsflag = false
	 },
    selectedservice(){},
    callParent() {
        this.startTrip = false;
        this.showAddShipment	= false
       // this.getTripData()
    },
    showTripMgmt() {
      this.clearEditField()
      this.$emit("goBackToParent")
    },
    async getCompanyShortName() {
        try {
		  let InputPayload = {};
          var CompanyShortList = [];
          let result = await ClientService.GetClientListByActiveContracts(InputPayload)
          CompanyShortList = result.data.data.rows;
          for (var i = 0; i < CompanyShortList.length; i++) {
            this.companyNamelist.push({
				'id': CompanyShortList[i].clientbusinessaccountid,
				'label': CompanyShortList[i].clientshortname,
				'ContractId': CompanyShortList[i].id,
				'CompanyName': CompanyShortList[i].clientcompanyname,
				'ClientId' : CompanyShortList[i].clientid,
				'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
				'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid
            })
          }
        } catch (err) {
          console.log(err);
        }
      },
	  isNumber: function(evt) {
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
		  evt.preventDefault();;
		} else {
		  return true;
		}
	  },
	  isCheckShipment(evt, item){
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
		  evt.preventDefault();
		} else {
		   if(evt.target.value<=0){
			if(item == 'noOfBoxes'){
				this.noOfBoxes = null
			} 
			else if(item == 'shipmentweight'){
				this.shipmentweight = null
			}	 
		   }
			if (item == 'shipmentweight') {
				if (Number(this.shipmentweight) <= Number(this.PRwtThreshold)) {
					this.thresholdErr = false;
					return true;
				} else {
					this.thresholdErr = true;
					this.shipmentweight = null
					evt.preventDefault();
				}
			} else {
				return true
			}
		}
	  },
	  isIntegerOnlty: function(evt) {
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if (charCode < 48 || charCode > 57) {
		  evt.preventDefault();;
		} else {
		  return true;
		}
	  },
	  resetPincode() {
		this.pickupPinCode = "";
		this.destinationPinCode = "";
		this.PickupPincodeServicable = 2;
		this.DestinationPincodeServicable = 2;
		this.OriginHub = '';
		this.OriginHubId = '';
		this.DestinationHub = '';
		this.DestinationHubId = '';
		this.PinCode = '';
		this.City = '';
		this.State = '';
		this.actualwtconfigparam = {};
		this.sourcepincodeerrmsg = '';
		this.destinationpincodeerrmsg = '';
		this.pincodeservicabilitycheckflag = false;
		this.Location = '';
		this.Mobile = '';
		this.telephone = '';
		this.Email = '';
		this.pickupAddress = '';
		this.LocationName = '';
		this.contactname = '';
		this.editLocation = false;
		this.editPincode = false;
		this.Location = null;
		this.AddNewLocationFlag = false;
		this.GstNo = null;
		this.Locationlist = []
	  },

	  async getPickupLocationList(clientid, pickuppincode, clientbusinessaccountid) {
		try {
		  this.Locationlist = [];
		  let InputPayload = {
			clientid: clientid,
			pincode: pickuppincode,
			clientbusinessaccountid: clientbusinessaccountid
		  }
		  this.contactpersonfirmname = this.businessaccountname
		  this.isBasicInfoLoading = true;
		  let result = await BookingService.getPickupLocationList(InputPayload);
		  let locationdata = result.data.data;
		  for (var i = 0; i < locationdata.length; i++) {
			this.Locationlist.push({
			  'id': locationdata[i].locationname,
			  'label': locationdata[i].locationname,
			  'mobile': locationdata[i].mobile,
			  'telephone': locationdata[i].telephone,
			  'email': locationdata[i].email,
			  'address': locationdata[i].address,
			  'gstno': locationdata[i].gstno
			})
		  }
		  if (this.Locationlist.length == 1 && this.Location == null) {
			this.Location = this.Locationlist[0];
			this.Mobile = this.Locationlist[0].mobile;
			this.telephone = this.Locationlist[0].telephone;
			this.Email = this.Locationlist[0].email;
			this.pickupAddress = this.Locationlist[0].address;
			this.GstNo = this.Locationlist[0].gstno
		  }
		  this.isBasicInfoLoading = false;
		} catch (err) {
		  console.log(err);
		  this.isBasicInfoLoading = false;
		}
	  },
	  async checkPincodeServicability() {
		try {
		  if (this.clientid == "") {
			this.$alert("Please select Client", "", "error");
			return false;
		  } 
		  if (!this.pickupPinCode && this.destinationPinCode) {
			this.$alert("Please enter Pickup Pincode", "", "error");
			return false;
		  } else if (this.pickupPinCode && !this.destinationPinCode) {
			this.$alert("Please enter Destination Pincode", "", "error");
			return false;
		  } else if (!this.pickupPinCode && !this.destinationPinCode) {
			this.$alert("Please enter Pickup & Destination Pincodes", "", "error");
			return false;
		  } else if (this.pickupPinCode.length < 6 || this.destinationPinCode.length < 6) {
			return false;
		  } 
		  else {
			var inputPayload = {};
			inputPayload.SourcePincode = this.pickupPinCode;
			inputPayload.DestinationPincode = this.destinationPinCode;
			inputPayload.ClientId = this.clientid;
			inputPayload.ClientBusinessAccountId = this.clientbusinessaccountid;
			inputPayload.TruckLoadType = this.TruckLoadType
			inputPayload.RouteMode = this.RouteMode
			inputPayload.BookingMode = this.BookingMode
			//if (this.userRoleFlag == 1) {
			//  inputPayload.defaultHubID = this.defaultHubID[0];
			//}
			this.isBasicInfoLoading = true;
			let result = await BookingService.checkPincodeServicability(inputPayload);
			this.isBasicInfoLoading = false;
			if (result.data.hasOwnProperty('data') && result.data.data) {
				if (result.data.data.hasOwnProperty('rateflag') && result.data.data.rateflag==false && result.data.data.hasOwnProperty('tatflag') && result.data.data.tatflag==false) {
					this.$alert(`Kindly add Rate and TAT for the Origin Destination "${inputPayload.SourcePincode} to ${inputPayload.DestinationPincode}" lane for client ${this.businessaccountname} before PRQ generation`, "", "error");
					return true
				} else if (result.data.data.hasOwnProperty('rateflag') && result.data.data.rateflag==false) {
					this.$alert(`Kindly add Rate for the Origin Destination "${inputPayload.SourcePincode} to ${inputPayload.DestinationPincode}" lane for client ${this.businessaccountname} before PRQ generation`, "", "error");
					return true
				} else if (result.data.data.hasOwnProperty('tatflag') && result.data.data.tatflag==false) {
					this.$alert(`Kindly add TAT for the Origin Destination "${inputPayload.SourcePincode} to ${inputPayload.DestinationPincode}" lane for client ${this.businessaccountname} before PRQ generation`, "", "error");
					return true
				}
			}
			if(result.data.code == 199){
				var WarningMsg = result.data.message;
				this.$confirm(WarningMsg," ","info").then(()=>{
				this.isBasicInfoLoading = true;
				this.setpincodedata(result);
				this.isBasicInfoLoading = false;
				}).catch((err)=>{
				this.isBasicInfoLoading = false;
				this.PickupPincodeServicable = 0;
				this.DestinationPincodeServicable = 0;
				this.actualwtconfigparam = {};
				console.log(err);
			});
			}else if(result.data.code == 200){	
			  this.isBasicInfoLoading = true;
			  this.setpincodedata(result);
			  this.isBasicInfoLoading = false;
			}else{
			  this.actualwtconfigparam = {};
			  this.$alert(result.data.message, "", "error");
			  this.isBasicInfoLoading = false;
			}
		  }
		} catch (err) {
		  this.isBasicInfoLoading = false;
		  this.$alert(err, "", "error");
		  this.PickupPincodeServicable = 0;
		  this.DestinationPincodeServicable = 0;
		  console.log(err);
		}
	  },
	  setpincodedata(result){
		this.actualwtconfigparam = result.data.data.contractratedata;
		if (result.data.data.sourcepincodedata) {
		  this.PickupPincodeServicable = 1;
		  this.OriginHub = result.data.data.sourcepincodedata.HubName;
		  this.OriginHubId = result.data.data.sourcepincodedata.HubID;
		  this.PinCode = this.pickupPinCode;
		  this.State = result.data.data.sourcepincodedata.StateName;
		  this.City = result.data.data.sourcepincodedata.CityName;
		} else {
		  this.PickupPincodeServicable = 0;
		  this.OriginHub = "";
		  this.OriginHubId = "";
		  this.PinCode = "";
		  this.State = "";
		  this.City = "";
		}
		if (result.data.data.destinationpincodedata) {
		  this.DestinationPincodeServicable = 1;
		  this.DestinationHub = result.data.data.destinationpincodedata.HubName;
		  this.DestinationHubId = result.data.data.destinationpincodedata.HubID;
		  this.ConsigneeState = result.data.data.destinationpincodedata.StateName;
		  this.ConsigneeCity = result.data.data.destinationpincodedata.CityName;
		} else {
		  this.DestinationPincodeServicable = 0;
		  this.DestinationHub = "";
		  this.DestinationHubId = "";
		}
  
		if (result.data.data.sourcepincodedata && result.data.data.destinationpincodedata) {
		  this.pincodeservicabilitycheckflag = true;
		  this.AddNewLocationFlag = false	
		  this.editLocation = true
		  this.editPincode = true
		  this.getPickupLocationList(this.clientid,this.pickupPinCode,this.clientbusinessaccountid)
		} else {
		  if (result.data.data.sourcepincodeerror) {
			this.sourcepincodeerrmsg = result.data.data.sourcepincodeerror;
		  }
		  if (result.data.data.destinationpincodeerror) {
			this.destinationpincodeerrmsg = result.data.data.destinationpincodeerror;
		  }
		}
	  },
	  async validateSaverequest() {
		this.$validator.validateAll("pickuplocationform").then((result) => {
		  if (result) {
			this.saveRequestPickup();
		  } else {
			return false;
		  }
		}).catch(() => {
		  console.log('errors exist');
		  return false;
		});
	  },
	  async saveRequestPickup(){
		try {
		  await this.getServerTime('save');
		  if (this.clientid == "") {
			this.$alert("Please select Client", "", "error");
			return false;
		  } 	
		  if (this.pincodeservicabilitycheckflag == false) {
			this.$alert("Please check pickup & destination Pincode serviceability", "", "error");
			return false;
		  }else if (this.PickupPincodeServicable != 1 && this.DestinationPincodeServicable != 1) {
			return false;
		  }else if(this.RequestedPickupDate <this.todaysDate && this.actiontype !=='edit') {
			return false;
		  }else if(this.AddNewLocationFlag == false && this.Location == null){
			this.$alert("Please select Location", "", "error");
			return false;
		  }
		  let inputPayload = {};
		  if (this.AddNewLocationFlag == true) {
			inputPayload.pickuplocation = this.LocationName;
		  } else {
			inputPayload.pickuplocation = this.Location.label
			inputPayload.LocationId = this.Location.id
		  }
		//  if(this.GstNo == ""){
		//	this.$alert("Please enter GST Number", "", "error");
		//	return false;
		//  }
		  if(this.actiontype == 'edit'){
			inputPayload.pickupid = this.requestpickupid	
			inputPayload.actiontype = this.actiontype	  
		}
		else{
			inputPayload.actiontype = this.actiontype	  
		}
			inputPayload.clientid = this.clientid;
			inputPayload.clientname = this.businessaccountname;
			inputPayload.clientbusinessaccountid = this.clientbusinessaccountid;
			inputPayload.routemode = this.RouteMode;
			inputPayload.bookingmode = this.BookingMode;
			inputPayload.truckloadtype = this.TruckLoadType
			inputPayload.pickuppincode = this.pickupPinCode;
			inputPayload.destinationpincode = this.destinationPinCode;
			inputPayload.originhubname = this.OriginHub;
			inputPayload.originhubid = this.OriginHubId;
			inputPayload.destinationhubname = this.DestinationHub;
			inputPayload.destinationhubid = this.DestinationHubId;
			inputPayload.pickupcity = this.City;
			inputPayload.pickupstate = this.State;
			inputPayload.destinationcity = this.ConsigneeCity;
			inputPayload.destinationstate = this.ConsigneeState;
			inputPayload.lastmodifiedby = this.userName;
			inputPayload.contactname =  this.contactpersonfirmname;
			inputPayload.email =  this.Email;
			inputPayload.physicalweight = this.shipmentweight ? this.shipmentweight : null;
			inputPayload.numberofmps = this.noOfBoxes ? this.noOfBoxes : null
			inputPayload.requestedpickupdate = this.RequestedPickupDate
			inputPayload.pickupinstruction= this.pickupInstruction
			inputPayload.pickupaddress = this.pickupAddress
			inputPayload.contactnumber = this.Mobile
			inputPayload.alternatecontact = this.telephone
			inputPayload.gstNo = this.GstNo
			this.isBasicInfoLoading = true;
			let result = await TripServices.savePickupRequest(inputPayload)
			this.isBasicInfoLoading = false;	
			if (result.data.code == 200) {
				if(this.actiontype == 'edit'){
					this.$alert(`You have successfully updated Pickup Request with ID ${this.requestpickupid}.`, "", "success");
				} else {
					this.$alert(`You have successfully created Pickup Request with ID ${result.data.data.id}.`, "", "success");
				}
				this.$emit("goBackToParent")
			  }else{
				document.activeElement.blur();
				this.$alert(result.data.message, "", "error");
			  }
		} catch (error) {
			this.isBasicInfoLoading = false;
			this.$alertify.error(error);
		}
	  },
	  UploadData() {
		this.currentTab = 2;
		this.uploadcsv = true;
	  },
	  async pickupDateselected() {
		try {
			this.PRCutoffcheck = false;
			let date = moment(this.RequestedPickupDate)
			let now = moment(this.serverdatetime);
			if (now > date && !this.updateflag && this.PRCutOffTime.length == 2) {
				let ltdate = moment(this.serverdatetime).tz('Asia/Kolkata').format('YYYY-MM-DD');
				let cutofftime1 = ltdate + " " + this.PRCutOffTime[0] + ":" + this.PRCutOffTime[1];
				let cutofftime = moment(cutofftime1)
				if (now.isAfter(cutofftime)) {
					this.PRCutoffcheck = true;
					this.RequestedPickupDate = moment(this.serverdatetime).add(1,'days').format("yyyy-MM-DD")
				}
			}
		} catch (error) {
			console.log(error);
		}
	  },
	  async getPRCutOffTime() {
		try {
			let InputPayload = {
				key : "PRCUTOFFTIME"
			}
			let result = await BookingService.GetConfigDetailsFromKey(InputPayload);
			if (result.data.data.value.length == 2) {
				this.PRCutOffTime = result.data.data.value;
				if (!this.updateflag) {
					this.pickupDateselected();					
				}
				let format  = this.PRCutOffTime[0] < 12 ? 'AM' : 'PM'
				  // this.PRCutOffTime[0] = this.PRCutOffTime[0]%12 || 12
				  this.prcutofftimestr = `${this.PRCutOffTime[0]%12 || 12}:${this.PRCutOffTime[1]} ${format}`;
			}
		} catch (error) {
			console.log(error);
		}
	  },
	  async getServerTime(type) {
		try {
			let inputPayload = {};
			let result = await TripServices.getServerDateTime(inputPayload)
			if (result.data) {
				this.serverdatetime = result.data;
				if (type=='mounted') {
					this.pickupDateselected();
				} else {
					await this.pickupDateselected();
				}
			}
		} catch (error) {
			
		}
	  },
	  async getPRWtThreshold() {
		try {
			let InputPayload = {
				key : "PRWEIGHTTHRESHOLD"
			}
			let result = await BookingService.GetConfigDetailsFromKey(InputPayload);
			if (result.data.data.value.length == 1) {
				this.PRwtThreshold = result.data.data.value[0];
			}
		} catch (error) {
			console.log(error);
		}
	  },
	  async checkbookingmode(){
		if(this.BookingMode == 'To Pay'){
			await this.$fire({
				text: "FTC booking mode is selected, Do you want to continue with FTC selection?",
				type: 'question',
				showCancelButton: true,
				confirmButtonText: 'Yes',
				cancelButtonText: 'No'
			  }).then((result) => {
				if(result.value == true) {
				  this.BookingMode = 'To Pay'
				}else{
					this.BookingMode = 'Credit'
				}
			  }).catch((err)=>{
			   console.log(err)
			  })
		  }
	  },
   
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/requestedpickupgeneration/createrequestedpickup/createrequestedpickup.component.js